// hooks/usePathHistory.ts
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const usePathHistory = () => {
  const location = useLocation();

  useEffect(() => {
    let pathHistory = [];

    try {
      pathHistory = JSON.parse(localStorage.getItem("pathHistory")) || [];
    } catch {
      localStorage.removeItem("pathHistory");
    }

    if (!Array.isArray(pathHistory)) pathHistory = [];
    const RESTRICTED_PATHS = [
      "/verification",
      "/login",
      "/signup",
      "/reset-password/new-password",
    ];
    const currentPath = location.pathname;

    if (RESTRICTED_PATHS.some((path) => currentPath.startsWith(path))) {
      return;
    }

    if (pathHistory.length === 0 || currentPath !== pathHistory[pathHistory.length - 1]) {
      const newHistory = [...pathHistory, currentPath].slice(-2); // Keep only the last two paths
      localStorage.setItem("pathHistory", JSON.stringify(newHistory));
    }
  }, [location.pathname]);
};

export default usePathHistory;
